module.exports = __webpack_public_path__ + "img/login_aziende.9ea381e1.jpg";